import optionTest from './option_test';
import tryTest from './try_test';
import tupleTest from './tuple-test';


export default {
    optionTest,
    tryTest,
    tupleTest
}
